import React from 'react';
import { useIntl } from 'react-intl';
import type { LyricFitStateName } from 'fym-shared/src/music24/story/lyricFit';
import { TypedMemo } from '../../../../../common/types';
import { lyricPanelMessages } from './lyricPanelMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the lyric panel; each part uses its own slice of it */
import styles from './LyricLinePanel.module.scss';
/* eslint-enable css-modules/no-unused-class */

const FIT_SHORT = {
  full: lyricPanelMessages.fitsShort,
  shrinks: lyricPanelMessages.shrinksShort,
  tooLong: lyricPanelMessages.tooLongShort,
} as const;

interface LyricSheetTriggerProps {
  value: string;
  onOpen: () => void;
}

/** Phone only: the row that opens the bottom sheet. It shows the picked line. */
const LyricSheetTriggerComponent: React.FC<LyricSheetTriggerProps> = ({ value, onOpen }) => {
  const intl = useIntl();
  return (
    <button type="button" className={styles.trigger} onClick={onOpen} aria-haspopup="dialog">
      <span className={styles.triggerText}>
        <small className={styles.headSub}>{intl.formatMessage(lyricPanelMessages.title)}</small>
        <b>{value === '' ? intl.formatMessage(lyricPanelMessages.noPick) : value}</b>
      </span>
      <span className={styles.triggerChange}>{intl.formatMessage(lyricPanelMessages.change)}</span>
    </button>
  );
};

export const LyricSheetTrigger = TypedMemo(LyricSheetTriggerComponent);

interface LyricSheetUseProps {
  value: string;
  chars: number;
  state: LyricFitStateName;
  onClose: () => void;
}

/** Phone only: the foot of the bottom sheet (design b4): the line, its fit and "Use this line". */
const LyricSheetUseComponent: React.FC<LyricSheetUseProps> = ({ value, chars, state, onClose }) => {
  const intl = useIntl();
  return (
    <div className={styles.useBar}>
      <span className={styles.useText}>
        <b>{value === '' ? intl.formatMessage(lyricPanelMessages.noPick) : value}</b>
        <span>
          {intl.formatMessage(lyricPanelMessages.characters, { count: chars })} &middot;{' '}
          {intl.formatMessage(FIT_SHORT[state])}
        </span>
      </span>
      <button type="button" className="btn btn-primary" onClick={onClose}>
        {intl.formatMessage(lyricPanelMessages.useLine)}
      </button>
    </div>
  );
};

export const LyricSheetUse = TypedMemo(LyricSheetUseComponent);
